declare const __ZEND_ASSET_REVISION__: string;

export const ASSET_REVISION = import.meta.env.PROD && typeof __ZEND_ASSET_REVISION__ !== "undefined" ? __ZEND_ASSET_REVISION__ : "";

/** A new service-worker cache alone does not bypass the browser's week-long HTTP cache. */
export function versionAsset(url: string, revision = ASSET_REVISION): string {
  if (!revision || /^(blob:|data:)/.test(url)) return url;
  const parsed = new URL(url, "https://zend.invalid");
  if (!parsed.pathname.startsWith("/assets/")) return url;
  parsed.searchParams.set("v", revision);
  return /^https?:\/\//.test(url) ? parsed.href : `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
